import { NavLink } from "react-router-dom";
import { BookOpen, Layers, Package, LayoutDashboard, LogOut, Send, Settings as Cog, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, id: "nav-dashboard" },
  { to: "/library", label: "Library", icon: BookOpen, id: "nav-library" },
  { to: "/series", label: "Series Shelf", icon: Layers, id: "nav-series" },
  { to: "/bundles", label: "Bundles", icon: Package, id: "nav-bundles" },
  { to: "/deliveries", label: "Deliveries", icon: Send, id: "nav-deliveries" },
  { to: "/store", label: "softspinepress.com", icon: Store, id: "nav-store" },
  { to: "/settings", label: "Brand & Logo", icon: Cog, id: "nav-settings" },
];

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <aside className="md:w-64 md:min-h-screen bg-[#38171E] text-[#F3E5AB] flex flex-wrap md:flex-nowrap md:flex-col shrink-0 md:sticky md:top-0 md:h-screen">
        <div className="p-4 md:p-6 border-b border-[#D4AF37]/25 flex md:block items-center gap-3">
          <div className="bg-[#FFFDF9] rounded-md p-2 md:p-3 shrink-0">
            <img src="/ssp-logo.png" alt="Soft Spine Press" className="h-9 md:h-auto md:w-full object-contain" data-testid="brand-logo" />
          </div>
          <div className="md:mt-4">
            <div className="font-display text-xl md:text-2xl leading-tight" data-testid="brand-mark">SSP Tools</div>
            <div className="text-[10px] tracking-[0.3em] text-[#D4AF37] mt-0.5">PUBLISHING STUDIO</div>
          </div>
        </div>
        <nav className="flex md:flex-col gap-1 p-3 md:p-4 flex-1 overflow-x-auto">
          {NAV.map(({ to, label, icon: Icon, id }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={id}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "bg-[#F3E5AB]/10 text-[#F3E5AB] border-l-2 border-[#D4AF37]" : "text-[#F3E5AB]/65 hover:text-[#F3E5AB] border-l-2 border-transparent"
                }`
              }
            >
              <Icon size={16} strokeWidth={1.5} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="md:hidden flex items-center px-3">
          <button onClick={logout} data-testid="mobile-logout-btn" aria-label="Sign out" className="p-2 text-[#F3E5AB]/80 hover:text-[#D4AF37]">
            <LogOut size={16} />
          </button>
        </div>
        <div className="hidden md:block p-6 border-t border-[#D4AF37]/25 text-xs text-[#F3E5AB]/60">
          <div className="truncate" data-testid="current-user-email">{user?.email}</div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="mt-3 flex items-center gap-2 text-[#F3E5AB]/80 hover:text-[#D4AF37] transition-colors"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
};

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 px-6 md:px-12 pt-10 md:pt-14 pb-8 border-b border-[#2A2325]/10 rise">
    <div>
      <div className="eyebrow mb-3">{eyebrow}</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-normal tracking-tight leading-none">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-3">{children}</div>
  </div>
);
